// ** Logo
// import logo from '@src/assets/images/logo/porsche-text.png'

import themeConfig from "@src/configs/themeConfig"

const SpinnerComponent = () => {
  return (
    <div className='fallback-spinner app-loader'>
      {/* <img className='fallback-logo' src={themeConfig.app.appLogoImage} alt='logo' width={"15%"}/> */}
      <div className='loading'>
        <div className='effect-1 effects'></div>
        <div className='effect-2 effects'></div>
        <div className='effect-3 effects'></div>
      </div>
    </div>
  )
}

export default SpinnerComponent
